// Leads
import * as AllLeadAction from "../redux/actions/allLeadsActions";
import * as OLALeadAction from "../redux/actions/olaLeadsAction";
import * as AmpereLeadAction from "../redux/actions/ampereAction";
import * as DialShreeLeadsAction from "../redux/actions/dialShreeLeadsAction";
import * as DialShreeInboundLeadsAction from "../redux/actions/dialShreeInboundLeadsAction";

// Columns
import { fetchColumns as fetchAllColumns } from "../redux/slices/columnsSlice";
import { savePreference } from "../redux/slices/preferenceSlice";

const leadConfig = {
    All: {
        actions: AllLeadAction,
        selector: (state) => state.leads,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        Filter: {
            date: [],
            filter_by_updated_at: [],
            tvs_retail_date: [],
            ola_retail_date: [],
            ola_verification_date: [],
            ola_order_status_date: [],
            ola_status_date: [],
            sub_brand: [],
            revolt_retail_date: [],
            otp_verified: [],
            otpsent: [],
            tvs_status: [],
            tvs_purchased_model: [],
            sub_brand_inc_date: [],
            source: [],
            subSource: [],
            // verification: [],
            tvs_verification: [],
            tvs_verification_inc_date: [],
            ola_verification: [],
            Ola_Verification_inc_date: [],
            brand: [],
            brand_inc_date: [],
            // Status: [],
            type: [],
            type_inc_date: [],
            loan: [],
            mobile: [],
            tvs_success_pincode: [],
            rejectmsg: [],
            Tenure: [],
            Down_Payment: [],
            Range: [],
            evifin: [],
            ecofy: [],
            pushed_to_tvs: [],
            pushed_to_tvs_inc_date: [],
            ampere_available: [],
            ampere_available_inc_date: [],
            evguru_updated: [],
            evguru_updated_inc_date: [],
            Battery_Wise_Exploration: [],
            call_yes: [],
            Language: [],
            revolt_verification: [],
            revolt_verification_inc_date: [],
            pushed_to_revolt: [],
            pushed_to_revolt_inc_date: [],
            send_to_revolt: [],
            revoltmodel: [],
            is_sent_to_revolt: [],
            revolt_status: [],
            revolt_booking_date: [],
            revolt_tr_completed_date: [],
            revolt_tr_scheduled_date: [],
            // Company: [],
            Renav: [],
            EVINDIA_CITY_NAME: [],
            Pincode: [],
            Pincode_inc_date: [],
            Po_State: [],
            Po_City: [],
            TC_State: [],
            ola_addon_status: [],
            Vida_Status: [],
            Vida_World_Verification: [],
            lead_pushed_to_ampere: [],
            lead_pushed_to_ampere_inc_date: [],
            cbrand: [],
            utm_medium: [],
            utm_campaign: [],
            utm_content: [],
            utm_term: [],
            ad_group: [],
        },
        FilterData: [
            {
                title: 'mobile',
                options: [],
                type: 'input'
            },
            {
                title: "date",
                options: [],
                type: 'daterange'
            },
            {
                title: "filter_by_updated_at",
                options: [],
                type: 'daterange'
            },
            {
                title: "tvs_retail_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "ola_retail_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "ola_verification_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "ola_status_date",
                options: [
                ],
                type: 'daterange'
            },
            {
                title: 'Brand',
                isSearchable: true,
                options: [
                    { label: 'Ola Electric EV', value: 'Ola Electric EV' },
                    { label: 'TVS EV', value: 'TVS EV' },
                    { label: 'VIDA World EV', value: 'VIDA World EV' },
                    { label: 'Ather Energy EV', value: 'Ather Energy EV' },
                    { label: 'Bounce Infinity', value: 'Bounce Infinity' },
                    { label: 'Joy e-bike', value: 'Joy e-bike' },
                    { label: 'Ampere', value: 'Ampere' },
                    { label: 'Kinetic Green', value: 'Kinetic Green' },
                    { label: 'All', value: 'Check all ev brands' },
                    { label: 'Suggest Me Brand', value: 'Suggest me best brand' }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "brand_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "sub_brand",
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "otp_verified",
                isSearchable: true,
                options: [],
                type: 'dropdown',
            },
            {
                title: "otpsent",
                isSearchable: true,
                options: [
                    { label: 'Sent', value: true },
                    { label: 'Not Sent', value: false }
                ],
                type: 'dropdown',
            },
            {
                title: "tvs_status",
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "tvs_purchased_model",
                isSearchable: true,
                options: [],
                type: 'dropdown',
            },
            {
                title: "sub_brand_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'tvs_success_pincode',
                options: [],
                type: 'input'
            },
            {
                title: 'source',
                isSearchable: true,
                options: [
                    { label: 'Landing Page', value: 1 },
                    { label: 'Fresh Work', value: 2 },
                    { label: 'FTBV', value: 3 },
                    { label: 'Inquiry', value: 4 },
                    { label: 'Whatsapp', value: 5 },
                    { label: 'New Freshmarketer', value: 6 },
                    { label: 'BotBuz', value: 7 },
                    { label: 'Excel', value: 8 },
                    { label: 'Vidyut Freshmarketer ', value: 9 },
                    { label: 'RENAV-FORM-INQUIRY', value: 10 },
                    { label: 'RENAV-WHATSAPP', value: 12 },
                    { label: 'RENAV-MISSED-CALL', value: 18 },
                    { label: 'TVS-LP', value: 11 },
                    { label: 'HP-LP', value: 13 },
                    { label: 'VIDA-LP', value: 14 },
                    { label: 'CL', value: 15 },
                    { label: 'TP', value: 16 },
                    { label: 'DS', value: 17 },
                    { label: 'RENAV-WHATSAPP-547', value: 19 },
                    { label: 'RENAV-WHATSAPP-348', value: 20 },
                    { label: 'RENAV-WHATSAPP-563', value: 21 },
                    { label: 'RENAV-WHATSAPP-507', value: 22 },
                    { label: 'RENAV-WHATSAPP-742', value: 23 },
                    { label: 'DIRECT-EXCEL', value: 24 },
                    { label: 'DIALSHREE-INBOUND-LEADS', value: 25 },
                    { label: 'OLA-EXCEL-IMPORT', value: 26 },
                    { label: 'GOOGLE-ADS', value: 27 },
                    { label: 'AMPERE-EXCEL-IMPORT', value: 28 },
                    { label: 'RETARGETTING', value: 29 },
                    { label: 'Listing Page', value: 30 },
                ],
                type: 'dropdown'
            },
            {
                title: 'subSource',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_medium',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_campaign',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_content',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_term',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'ad_group',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Renav',
                options: [
                    { label: 'true', value: 'true' },
                    { label: 'false', value: 'false' },
                ],
                type: 'checkbox'
            },
            {
                title: 'evguru_updated',
                options: [
                    { label: 'true', value: 'true' },
                    { label: 'false', value: 'false' },
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "evguru_updated_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'ola_addon_status',
                isSearchable: true,
                options: [
                    { value: "EC_APPOINTMENT_SCHEDULED", label: "EC Appointment Scheduled" },
                    { value: "EC_TR_COMPLETED", label: "EC Test Ride Completed" },
                    { value: "HOME_TR_SCHEDULED", label: "Home Test Ride Scheduled" },
                    { value: "EC_CHECK_IN", label: "EC Check-in" },
                    { value: "HOME_TR_COMPLETED", label: "Home Test Ride Completed" },
                ],
                type: 'dropdown',
                isSingleSelection: true
            },
            {
                title: 'Evifin',
                options: [
                    { label: 'Available', value: 1 },
                    { label: 'Unavailable', value: 2 },
                ],
                type: 'checkbox'
            },
            {
                title: 'Ecofy',
                options: [
                    { label: 'Available', value: 1 },
                    { label: 'Unavailable', value: 2 },
                ],
                type: 'checkbox'
            },
            {
                title: 'Loan',
                options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                ],
                type: 'checkbox'
            },
            {
                title: 'type',
                isSearchable: true,
                options: [
                    { label: 'Test Ride', value: 1 },
                    { label: 'On Road Price', value: 2 },
                    { label: 'Offers', value: 3 },
                    { label: 'Home Test Ride', value: 4 },
                    { label: 'Loan', value: 5 }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "type_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'Range',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'lead_pushed_to_ampere',
                options: [
                    { label: 'Success', value: 1 },
                    { label: 'UnSuccess', value: 2 },
                    { label: 'Duplicate', value: 3 },
                    { label: 'Not eligible', value: 4 },
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "lead_pushed_to_ampere_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'pushed_to_revolt',
                isSearchable: true,
                options: [
                    { label: 'Pending', value: 0 },
                    { label: 'Completed', value: 1 },
                    { label: 'Duplicate', value: 2 },
                    { label: 'Failed', value: 3 },
                    { label: 'Not eligible', value: 4 },
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "pushed_to_revolt_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'Battery_Wise_Exploration',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'call_yes',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Ola_Verification',
                isSearchable: true,
                options: [
                    { label: 'Accepted', value: 1 },
                    { label: 'Rejected', value: 2 },
                    { label: 'Un Processed', value: 3 },
                    { label: 'Duplicate', value: 4 },
                    { label: 'Store(B)', value: 7 },
                    { label: 'Store(A)', value: 8 },
                    { label: 'Not Eligible', value: 5 }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "Ola_Verification_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'Ola_Status',
                options: []  // Dynamic fetching of status fields
            },
            {
                title: 'RejectMsg',
                isSearchable: true,
                options: [
                    { label: 'There is a existing lead with the same phone number', value: 1 },
                    { label: 'The phone number is already a customer', value: 2 },
                    { label: 'The phone number is mapped to multiple leads', value: 3 }
                ],
                type: 'dropdown'
            },
            {
                title: 'Down_Payment',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Language',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Tenure',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'tvs_verification',
                isSearchable: true,
                options: [
                    { label: 'Accepted', value: 1 },
                    { label: 'Rejected', value: 2 },
                    { label: 'Un Processed', value: 3 },
                    { label: 'Duplicate', value: 4 },
                    { label: 'Dealer Not Found', value: 5 },
                    { label: 'Old Leads', value: 6 }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "tvs_verification_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'pushed_to_tvs',
                options: [
                    { label: 'Completed', value: 1 },
                    { label: 'Pending', value: 2 },
                    { label: 'Rejected', value: 3 },
                    { label: 'Not Eligible', value: 4 },
                    { label: 'DUPLICATE_LEAD', value: 5 },
                    { label: 'Failed to allocate dealer', value: 6 },
                    { label: 'INVALID_PINCODE', value: 7 },
                    { label: 'Success', value: 8 },
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "pushed_to_tvs_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'Vida_World_Verification',
                options: [
                    { label: 'Accepted', value: 1 },
                    { label: 'Rejected', value: 2 },
                    { label: 'Un Processed', value: 3 },
                    { label: 'Duplicate', value: 4 }
                ],
                type: 'checkbox'
            },
            {
                title: 'Vida_Status',
                options: []  // Dynamic fetching of status fields
            },
            {
                title: 'ampere_available',
                options: [
                    { label: 'Available', value: 1 },
                    { label: 'Unavailable', value: 2 },
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "ampere_available_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "revolt_retail_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "revolt_booking_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "revolt_tr_completed_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "revolt_tr_scheduled_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "send_to_revolt",
                options: [
                    { label: "Yes", value: "true" },
                    { label: "No", value: "false" }
                ],
                type: 'dropdown'
            },
            {
                title: "is_sent_to_revolt",
                options: [
                    { label: "Yes", value: "true" },
                    { label: "No", value: "false" }
                ],
                type: 'dropdown'
            },
            {
                title: "revolt_status",
                options: [
                    { label: "Retailed", value: "1" },
                    { label: "Booked", value: "2" },
                    { label: "Test Ride Completed", value: "3" },
                    { label: "Test Ride Scheduled", value: "4" }
                ],
                type: 'dropdown'
            },
            {
                title: "revoltmodel",
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'revolt_verification',
                options: [
                    { label: 'Accepted', value: 1 },
                    { label: 'Rejected', value: 2 },
                    { label: 'Not eligible', value: 3 }
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "revolt_verification_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'Renav',
                options: [
                    { label: 'true', value: true },
                    { label: 'false', value: false },
                ],
                type: 'checkbox'
            },
            {
                title: 'EVINDIA_CITY_NAME',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Pincode',
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "Pincode_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'PO_State',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'PO_City',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'TC_State',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Vida_World_Verification',
                options: [
                    { label: 'Accepted', value: 1 },
                    { label: 'Rejected', value: 2 },
                    { label: 'Un Processed', value: 3 },
                    { label: 'Duplicate', value: 4 }
                ],
                type: 'checkbox'
            },
            {
                title: 'Vida_Status',
                options: []  // Dynamic fetching of status fields
            },
            {
                title: 'cbrand',
                isSearchable: true,
                options: [],
                type: 'dropdown',
            },
        ],
        permissionKey: "LEADS",
        savePreference: true,
        columnType: "AllLeads",
    },
    Ampere: {
        // actions: AllLeadAction,
        // selector: (state) => state.ampereLeads,
        actions: AllLeadAction,
        selector: (state) => state.leads,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        Filter: {
            mobile: [],
            date: [],
            source: [],
            subSource: [],
            lead_pushed_to_ampere: [],
            lead_pushed_to_ampere_inc_date: [],
            filter_by_updated_at: [],
            tvs_retail_Date: [],
            brand: [],
            cbrand: [],
        },
        FilterData: [
            {
                title: "date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'mobile',
                options: [],
                type: 'input'
            },
            {
                title: 'source',
                isSearchable: true,
                options: [
                    { label: 'DIRECT-EXCEL', value: 24 },
                    { label: 'AMPERE-EXCEL-IMPORT', value: 28 },
                ],
                type: 'dropdown'
            },
            {
                title: 'subSource',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'lead_pushed_to_ampere',
                options: [
                    { label: 'Success', value: 1 },
                    { label: 'UnSuccess', value: 2 },
                    { label: 'Duplicate', value: 3 },
                    { label: 'Not eligible', value: 4 },
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "lead_pushed_to_ampere_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'cbrand',
                isSearchable: true,
                options: [],
                type: 'dropdown',
            },
            {
                title: "filter_by_updated_at",
                options: [],
                type: 'daterange'
            },
            {
                title: "tvs_retail_Date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'Brand',
                isSearchable: true,
                options: [
                    { label: 'Ola Electric EV', value: 'Ola Electric EV' },
                    { label: 'TVS EV', value: 'TVS EV' },
                    { label: 'VIDA World EV', value: 'VIDA World EV' },
                    { label: 'Ather Energy EV', value: 'Ather Energy EV' },
                    { label: 'Bounce Infinity', value: 'Bounce Infinity' },
                    { label: 'Joy e-bike', value: 'Joy e-bike' },
                    { label: 'Ampere', value: 'Ampere' },
                    { label: 'Kinetic Green', value: 'Kinetic Green' },
                    { label: 'All', value: 'Check all ev brands' },
                    { label: 'Suggest Me Brand', value: 'Suggest me best brand' }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
        ],
        permissionKey: "AMPERE",
        savePreference: true,
        columnType: "AmpereLeads",
    },
    Simple: {
        actions: AllLeadAction,
        selector: (state) => state.leads,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        Filter: {
            mobile: [],
            date: [],
            filter_by_updated_at: [],
            source: [],
            subSource: [],
            pushed_to_simple: [],
            pushed_to_simple_inc_date: [],
            simple_verification: [],
            simple_verification_inc_date: [],
            simple_pincode_verified: [],
            simple_call_verification: [],
            simple_sent_by: [],
            type: [],
            type_inc_date: [],
            brand: [],
            brand_inc_date: [],
            cbrand: [],
            Pincode: [],
            Pincode_inc_date: [],
            EVINDIA_CITY_NAME: [],
            PO_State: [],
            PO_City: [],
            utm_medium: [],
            utm_campaign: [],
            utm_content: [],
            utm_term: [],
            ad_group: [],
        },
        FilterData: [
            {
                title: "date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'mobile',
                options: [],
                type: 'input'
            },
            {
                title: "filter_by_updated_at",
                options: [],
                type: 'daterange'
            },
            {
                title: 'source',
                isSearchable: true,
                options: [
                    { label: 'Landing Page', value: 1 },
                    { label: 'Fresh Work', value: 2 },
                    { label: 'FTBV', value: 3 },
                    { label: 'Inquiry', value: 4 },
                    { label: 'Whatsapp', value: 5 },
                    { label: 'New Freshmarketer', value: 6 },
                    { label: 'BotBuz', value: 7 },
                    { label: 'Excel', value: 8 },
                    { label: 'Vidyut Freshmarketer ', value: 9 },
                    { label: 'RENAV-FORM-INQUIRY', value: 10 },
                    { label: 'RENAV-WHATSAPP', value: 12 },
                    { label: 'RENAV-MISSED-CALL', value: 18 },
                    { label: 'TVS-LP', value: 11 },
                    { label: 'HP-LP', value: 13 },
                    { label: 'VIDA-LP', value: 14 },
                    { label: 'CL', value: 15 },
                    { label: 'TP', value: 16 },
                    { label: 'DS', value: 17 },
                    { label: 'RENAV-WHATSAPP-547', value: 19 },
                    { label: 'RENAV-WHATSAPP-348', value: 20 },
                    { label: 'RENAV-WHATSAPP-563', value: 21 },
                    { label: 'RENAV-WHATSAPP-507', value: 22 },
                    { label: 'RENAV-WHATSAPP-742', value: 23 },
                    { label: 'DIRECT-EXCEL', value: 24 },
                    { label: 'DIALSHREE-INBOUND-LEADS', value: 25 },
                    { label: 'OLA-EXCEL-IMPORT', value: 26 },
                    { label: 'GOOGLE-ADS', value: 27 },
                    { label: 'AMPERE-EXCEL-IMPORT', value: 28 },
                    { label: 'RETARGETTING', value: 29 },
                    { label: 'Listing Page', value: 30 },
                ],
                type: 'dropdown'
            },
            {
                title: 'subSource',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'pushed_to_simple',
                options: [
                    { label: 'Success', value: 1 },
                    { label: 'Pending', value: 2 },
                    { label: 'Failed', value: 3 },
                    { label: 'Duplicate', value: 4 },
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "pushed_to_simple_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'simple_verification',
                options: [
                    { label: 'Accepted', value: 1 },
                    { label: 'Rejected', value: 2 },
                    { label: 'Pending', value: 3 },
                    { label: 'Duplicate', value: 4 },
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: 'simple_pincode_verified',
                options: [
                    { label: 'Verified', value: 1 },
                    { label: 'Unverified', value: 2 },
                ],
                type: 'dropdown',
            },
            {
                title: 'simple_call_verification',
                options: [
                    { label: 'Pending', value: 0 },
                    { label: 'Interested', value: 1 },
                    { label: 'Not Interested', value: 2 },
                    { label: 'Schedule', value: 3 },
                ],
                type: 'dropdown',
            },
            {
                title: 'simple_sent_by',
                isSearchable: true,
                options: [],
                type: 'dropdown',
            },
            {
                title: "simple_verification_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'type',
                isSearchable: true,
                options: [
                    { label: 'Test Ride', value: 1 },
                    { label: 'On Road Price', value: 2 },
                    { label: 'Offers', value: 3 },
                    { label: 'Home Test Ride', value: 4 },
                    { label: 'Loan', value: 5 }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "type_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'Brand',
                isSearchable: true,
                options: [
                    { label: 'Ola Electric EV', value: 'Ola Electric EV' },
                    { label: 'TVS EV', value: 'TVS EV' },
                    { label: 'VIDA World EV', value: 'VIDA World EV' },
                    { label: 'Ather Energy EV', value: 'Ather Energy EV' },
                    { label: 'Bounce Infinity', value: 'Bounce Infinity' },
                    { label: 'Joy e-bike', value: 'Joy e-bike' },
                    { label: 'Ampere', value: 'Ampere' },
                    { label: 'Kinetic Green', value: 'Kinetic Green' },
                    { label: 'Simple Energy', value: 'Simple Energy' },
                    { label: 'All', value: 'Check all ev brands' },
                    { label: 'Suggest Me Brand', value: 'Suggest me best brand' }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "brand_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'cbrand',
                isSearchable: true,
                options: [],
                type: 'dropdown',
            },
            {
                title: 'Pincode',
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "Pincode_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'EVINDIA_CITY_NAME',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'PO_State',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'PO_City',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_medium',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_campaign',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_content',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_term',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'ad_group',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
        ],
        permissionKey: "SIMPLE_LEADS",
        savePreference: true,
        columnType: "SimpleLeads",
    },
    Revolt: {
        actions: AllLeadAction,
        selector: (state) => state.leads,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        Filter: {
            mobile: [],
            source: [],
            subSource: [],
            filter_by_updated_at: [],
            tvs_retail_Date: [],
            pushed_to_revolt: [],
            pushed_to_revolt_inc_date: [],
            date: [],
            revolt_verification: [],
            revolt_verification_inc_date: [],
            cbrand: [],
            brand: [],
            revolt_retail_date: [],
            send_to_revolt: [],
            revoltmodel: [],
            is_sent_to_revolt: [],
            revolt_status: [],
            revolt_booking_date: [],
            revolt_tr_completed_date: [],
            revolt_tr_scheduled_date: [],
        },
        FilterData: [
            {
                title: "date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'mobile',
                options: [],
                type: 'input'
            },
            {
                title: "filter_by_updated_at",
                options: [],
                type: 'daterange'
            },
            {
                title: "tvs_retail_Date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'source',
                isSearchable: true,
                options: [
                    { label: 'Fresh-Work', value: 2 },
                    { label: 'The-Messenger-547', value: 19 },
                    { label: 'DIRECT-EXCEL', value: 24 },
                ],
                type: 'dropdown'
            },
            {
                title: 'subSource',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: "revolt_retail_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "revolt_booking_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "revolt_tr_completed_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "revolt_tr_scheduled_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "send_to_revolt",
                options: [
                    { label: "Yes", value: "true" },
                    { label: "No", value: "false" }
                ],
                type: 'dropdown'
            },
            {
                title: "is_sent_to_revolt",
                options: [
                    { label: "Yes", value: "true" },
                    { label: "No", value: "false" }
                ],
                type: 'dropdown'
            },
            {
                title: "revolt_status",
                options: [
                    { label: "Retailed", value: "1" },
                    { label: "Booked", value: "2" },
                    { label: "Test Ride Completed", value: "3" },
                    { label: "Test Ride Scheduled", value: "4" }
                ],
                type: 'dropdown'
            },
            {
                title: "revoltmodel",
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'pushed_to_revolt',
                isSearchable: true,
                options: [
                    { label: 'Pending', value: 0 },
                    { label: 'Completed', value: 1 },
                    { label: 'Duplicate', value: 2 },
                    { label: 'Failed', value: 3 },
                    { label: 'Not eligible', value: 4 },
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "pushed_to_revolt_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'Brand',
                isSearchable: true,
                options: [
                    { label: 'Ola Electric EV', value: 'Ola Electric EV' },
                    { label: 'TVS EV', value: 'TVS EV' },
                    { label: 'VIDA World EV', value: 'VIDA World EV' },
                    { label: 'Ather Energy EV', value: 'Ather Energy EV' },
                    { label: 'Bounce Infinity', value: 'Bounce Infinity' },
                    { label: 'Joy e-bike', value: 'Joy e-bike' },
                    { label: 'Ampere', value: 'Ampere' },
                    { label: 'Kinetic Green', value: 'Kinetic Green' },
                    { label: 'All', value: 'Check all ev brands' },
                    { label: 'Suggest Me Brand', value: 'Suggest me best brand' }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: 'cbrand',
                isSearchable: true,
                options: [],
                type: 'dropdown',
            },
            {
                title: 'revolt_verification',
                options: [
                    { label: 'Accepted', value: 1 },
                    { label: 'Rejected', value: 2 },
                    { label: 'Not eligible', value: 3 }
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "revolt_verification_inc_date",
                options: [],
                type: 'daterange'
            },
        ],
        permissionKey: "REVOLTLEADS",
        savePreference: true,
        columnType: "RevoltLeads",
    },
    Tvs: {
        actions: AllLeadAction,
        selector: (state) => state.leads,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        Filter: {
            mobile: [],
            tvs_success_pincode: [],
            source: [],
            subSource: [],
            date: [],
            filter_by_updated_at: [],
            tvs_retail_Date: [],
            type: [],
            type_inc_date: [],
            pushed_to_tvs: [],
            pushed_to_tvs_inc_date: [],
            tvs_verification: [],
            tvs_verification_inc_date: [],
            evifin: [],
            sub_brand: [],
            otp_verified: [],
            otpsent: [],
            tvs_status: [],
            tvs_purchased_model: [],
            sub_brand_inc_date: [],
            ecofy: [],
            RejectMsg: [],
            Ola_Status: [],
            cbrand: [],
            brand: [],
        },
        FilterData: [
            {
                title: "date",
                options: [],
                type: 'daterange'
            },
            {
                title: "filter_by_updated_at",
                options: [],
                type: 'daterange'
            },
            {
                title: "tvs_retail_Date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'mobile',
                options: [],
                type: 'input'
            },
            {
                title: 'tvs_success_pincode',
                options: [],
                type: 'input'
            },
            {
                title: 'cbrand',
                isSearchable: true,
                options: [],
                type: 'dropdown',
            },
            {
                title: 'source',
                isSearchable: true,
                options: [
                    { label: 'Landing Page', value: 1 },
                    { label: 'Fresh Work', value: 2 },
                    { label: 'FTBV', value: 3 },
                    { label: 'Inquiry', value: 4 },
                    { label: 'Whatsapp', value: 5 },
                    { label: 'New Freshmarketer', value: 6 },
                    { label: 'BotBuz', value: 7 },
                    { label: 'Excel', value: 8 },
                    { label: 'Vidyut Freshmarketer ', value: 9 },
                    { label: 'RENAV-FORM-INQUIRY', value: 10 },
                    { label: 'RENAV-WHATSAPP', value: 12 },
                    { label: 'RENAV-MISSED-CALL', value: 18 },
                    { label: 'TVS-LP', value: 11 },
                    { label: 'HP-LP', value: 13 },
                    { label: 'VIDA-LP', value: 14 },
                    { label: 'CL', value: 15 },
                    { label: 'TP', value: 16 },
                    { label: 'DS', value: 17 },
                    { label: 'RENAV-WHATSAPP-547', value: 19 },
                    { label: 'RENAV-WHATSAPP-348', value: 20 },
                    { label: 'RENAV-WHATSAPP-563', value: 21 },
                    { label: 'RENAV-WHATSAPP-507', value: 22 },
                    { label: 'RENAV-WHATSAPP-742', value: 23 },
                    { label: 'DIRECT-EXCEL', value: 24 },
                    { label: 'DIALSHREE-INBOUND-LEADS', value: 25 },

                ],
                type: 'dropdown'
            },
            {
                title: 'subSource',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: "sub_brand",
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "otp_verified",
                isSearchable: true,
                options: [],
                type: 'dropdown',
            },
            {
                title: "otpsent",
                isSearchable: true,
                options: [
                    { label: 'Sent', value: true },
                    { label: 'Not Sent', value: false }
                ],
                type: 'dropdown',
            },
            {
                title: "tvs_status",
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "tvs_purchased_model",
                isSearchable: true,
                options: [],
                type: 'dropdown',
            },
            {
                title: "sub_brand_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'type',
                isSearchable: true,
                options: [
                    { label: 'Test Ride', value: 1 },
                    { label: 'On Road Price', value: 2 },
                    { label: 'Offers', value: 3 },
                    { label: 'Home Test Ride', value: 4 },
                    { label: 'Loan', value: 5 }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: 'Brand',
                isSearchable: true,
                options: [
                    { label: 'Ola Electric EV', value: 'Ola Electric EV' },
                    { label: 'TVS EV', value: 'TVS EV' },
                    { label: 'VIDA World EV', value: 'VIDA World EV' },
                    { label: 'Ather Energy EV', value: 'Ather Energy EV' },
                    { label: 'Bounce Infinity', value: 'Bounce Infinity' },
                    { label: 'Joy e-bike', value: 'Joy e-bike' },
                    { label: 'Ampere', value: 'Ampere' },
                    { label: 'Kinetic Green', value: 'Kinetic Green' },
                    { label: 'All', value: 'Check all ev brands' },
                    { label: 'Suggest Me Brand', value: 'Suggest me best brand' }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "type_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'tvs_verification',
                isSearchable: true,
                options: [
                    { label: 'Accepted', value: 1 },
                    { label: 'Rejected', value: 2 },
                    { label: 'Un Processed', value: 3 },
                    { label: 'Duplicate', value: 4 },
                    { label: 'Dealer Not Found', value: 5 },
                    { label: 'Old Leads', value: 6 }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "tvs_verification_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'pushed_to_tvs',
                options: [
                    { label: 'Completed', value: 1 },
                    { label: 'Pending', value: 2 },
                    { label: 'Rejected', value: 3 },
                    { label: 'Not Eligible', value: 4 },
                    { label: 'DUPLICATE_LEAD', value: 5 },
                    { label: 'Failed to allocate dealer', value: 6 },
                    { label: 'INVALID_PINCODE', value: 7 },
                    { label: 'Success', value: 8 },
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "pushed_to_tvs_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'Evifin',
                options: [
                    { label: 'Available', value: 1 },
                    { label: 'Unavailable', value: 2 },
                ],
                type: 'checkbox'
            },
            {
                title: 'Ecofy',
                options: [
                    { label: 'Available', value: 1 },
                    { label: 'Unavailable', value: 2 },
                ],
                type: 'checkbox'
            },
            {
                title: 'RejectMsg',
                isSearchable: true,
                options: [
                    { label: 'There is a existing lead with the same phone number', value: 1 },
                    { label: 'The phone number is already a customer', value: 2 },
                    { label: 'The phone number is mapped to multiple leads', value: 3 }
                ],
                type: 'dropdown'
            },
            {
                title: 'Ola_Status',
                isSearchable: true,
                options: [
                    { label: 'No Progress', value: 'No Progress' },
                    { label: 'WIP', value: 'WIP' },
                    { label: 'CONVERTED', value: 'CONVERTED' },
                    { label: 'LOST', value: 'LOST' }
                ],
                type: 'dropdown'
            },
        ],
        permissionKey: "TVSLEADS",
        savePreference: true,
        columnType: "TvsLeads",
    },
    Dialshree: {
        actions: DialShreeLeadsAction,
        selector: (state) => state.dialShreeLeads,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        Filter: {
            date: [],
            source: [],
            state: [],
            pincode: [],
            evindia_city: [],
            evindia_brand: [],
            loan: [],
            tenure: [],
            down_payment: [],
            range: [],
        },
        FilterData: [
            {
                title: "date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'source',
                isSearchable: true,
                options: [
                ],
                type: 'dropdown'
            },
            {
                title: 'state',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'pincode',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'evindia_city',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'evindia_brand',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'loan',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'tenure',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'down_payment',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'range',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
        ],
        permissionKey: "DIALSHREE",
        savePreference: true,
        columnType: "DialshreeLeads",
    },
    Dialshreeinbound: {
        actions: DialShreeInboundLeadsAction,
        selector: (state) => state.dialShreeInboundLeads,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        Filter: {
            date: [],
            call_description: [],
            status: [],
            callType: [],
            source: [],
            subSource: [],
            mobile: [],
            city: [],
            state: [],
            postal_code: [],
            lead_send_to: [],
        },
        FilterData: [
            {
                title: "date",
                options: [],
                type: 'daterange'
            },
            { title: 'call_description', options: [], type: 'dropdown' },
            { title: 'status', options: [], type: 'dropdown' },
            { title: 'callType', options: [], type: 'dropdown' },
            { title: 'source', options: [], type: 'dropdown' },
            { title: 'subSource', options: [], type: 'dropdown', isSearchable: true },
            { title: 'mobile', options: [], type: 'input' },
            { title: 'city', options: [], type: 'dropdown' },
            { title: 'state', options: [], type: 'dropdown' },
            {
                title: 'lead_send_to',
                isSearchable: true,
                options: [
                    { label: 'OLA', value: 1 },
                ], type: 'dropdown'
            },
            { title: 'postal_code', options: [], type: 'dropdown' },
        ],
        permissionKey: "DIALSHREE",
        savePreference: true,
        columnType: "DialshreeInboundLeads",
    },
    Ola: {
        actions: AllLeadAction,
        selector: (state) => state.leads,
        columnSelector: (state) => state.columns,
        fetchColumns: fetchAllColumns,
        Filter: {
            mobile: [],
            date: [],
            filter_by_updated_at: [],
            tvs_retail_Date: [],
            ola_order_status_date: [],
            brand: [],
            sub_brand: [],
            otp_verified: [],
            otpsent: [],
            tvs_status: [],
            tvs_purchased_model: [],
            sub_brand_inc_date: [],
            source: [],
            subSource: [],
            type: [],
            type_inc_date: [],

            revolt_verification: [],
            pushed_to_revolt: [],
            pushed_to_revolt_inc_date: [],
            ola_retail_date: [],
            ola_verification_date: [],

            tvs_verification: [],
            tvs_verification_inc_date: [],
            pushed_to_tvs: [],
            pushed_to_tvs_inc_date: [],

            ola_verification: [],
            Ola_Verification_inc_date: [],
            ola_addon_status: [],
            ola_status_date: [],

            ampere_available: [],
            ampere_available_inc_date: [],
            evguru_updated: [],
            rejectmsg: [],
            Ola_Status: [],
            Pincode: [],
            Pincode_inc_date: [],
            // verification: [],

            Po_State: [],
            Po_City: [],
            TC_State: [],
            EVINDIA_CITY_NAME: [],


            loan: [],
            Tenure: [],
            Down_Payment: [],
            Range: [],
            evifin: [],
            ecofy: [],

            Battery_Wise_Exploration: [],
            call_yes: [],
            Language: [],

            formType: [],
            dealer: [],
            dealer_inc_date: [],
            Renav: [],
            area: [],
            area_inc_date: [],

            tvs_success_pincode: [],
            cbrand: [],
            utm_medium: [],
            utm_campaign: [],
            utm_content: [],
            utm_term: [],
            ad_group: [],
        },
        FilterData: [
            {
                title: "date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'mobile',
                options: [],
                type: 'input'
            },
            {
                title: "filter_by_updated_at",
                options: [],
                type: 'daterange'
            },
            {
                title: "ola_order_status_date",
                options: [
                ],
                type: 'daterange'
            },
            {
                title: "tvs_retail_Date",
                options: [
                ],
                type: 'daterange'
            },
            {
                title: "ola_retail_date",
                options: [],
                type: 'daterange'
            },
            {
                title: "ola_verification_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'Brand',
                isSearchable: true,
                options: [
                    { label: 'Ola Electric EV', value: 'Ola Electric EV' },
                    { label: 'TVS EV', value: 'TVS EV' },
                    { label: 'VIDA World EV', value: 'VIDA World EV' },
                    { label: 'Ather Energy EV', value: 'Ather Energy EV' },
                    { label: 'Bounce Infinity', value: 'Bounce Infinity' },
                    { label: 'Joy e-bike', value: 'Joy e-bike' },
                    { label: 'Ampere', value: 'Ampere' },
                    { label: 'Kinetic Green', value: 'Kinetic Green' },
                    { label: 'All', value: 'Check all ev brands' },
                    { label: 'Suggest Me Brand', value: 'Suggest me best brand' }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "sub_brand",
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "otp_verified",
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: "otpsent",
                isSearchable: true,
                options: [
                    { label: 'Sent', value: true },
                    { label: 'Not Sent', value: false }
                ],
                type: 'dropdown'
            },
            {
                title: 'tvs_success_pincode',
                options: [],
                type: 'input'
            },
            {
                title: "tvs_status",
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: 'cbrand',
                isSearchable: true,
                options: [],
                type: 'dropdown',
            },
            {
                title: "tvs_purchased_model",
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "sub_brand_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'source',
                isSearchable: true,
                options: [
                    { label: 'Landing Page', value: 1 },
                    { label: 'Fresh Work', value: 2 },
                    { label: 'FTBV', value: 3 },
                    { label: 'Inquiry', value: 4 },
                    { label: 'Whatsapp', value: 5 },
                    { label: 'New Freshmarketer', value: 6 },
                    { label: 'BotBuz', value: 7 },
                    { label: 'Excel', value: 8 },
                    { label: 'Vidyut Freshmarketer ', value: 9 },
                    { label: 'RENAV-FORM-INQUIRY', value: 10 },
                    { label: 'RENAV-WHATSAPP', value: 12 },
                    { label: 'RENAV-MISSED-CALL', value: 18 },
                    { label: 'TVS-LP', value: 11 },
                    { label: 'HP-LP', value: 13 },
                    { label: 'VIDA-LP', value: 14 },
                    { label: 'CL', value: 15 },
                    { label: 'TP', value: 16 },
                    { label: 'DS', value: 17 },
                    { label: 'RENAV-WHATSAPP-547', value: 19 },
                    { label: 'RENAV-WHATSAPP-348', value: 20 },
                    { label: 'RENAV-WHATSAPP-563', value: 21 },
                    { label: 'RENAV-WHATSAPP-507', value: 22 },
                    { label: 'RENAV-WHATSAPP-742', value: 23 },
                    { label: 'DIRECT-EXCEL', value: 24 },
                    { label: 'DIALSHREE-INBOUND-LEADS', value: 25 },
                    { label: 'OLA-EXCEL-IMPORT', value: 26 },
                    { label: 'GOOGLE-ADS', value: 27 },
                    { label: 'AMPERE-EXCEL-IMPORT', value: 28 },
                    { label: 'RETARGETTING', value: 29 },
                    { label: 'Listing Page', value: 30 },
                ],
                type: 'dropdown'
            },
            {
                title: 'subSource',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_medium',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_campaign',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_content',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'utm_term',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'ad_group',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Type',
                isSearchable: true,
                options: [
                    { label: 'Test Ride', value: 1 },
                    { label: 'On Road Price', value: 2 },
                    { label: 'Offers', value: 3 },
                    { label: 'Home Test Ride', value: 4 },
                    { label: 'Loan', value: 5 }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: 'revolt_verification',
                options: [
                    { label: 'Accepted', value: 1 },
                    { label: 'Rejected', value: 2 }
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "revolt_verification_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'pushed_to_revolt',
                isSearchable: true,
                options: [
                    { label: 'Pending', value: 0 },
                    { label: 'Completed', value: 1 },
                    { label: 'Duplicate', value: 2 },
                    { label: 'Failed', value: 3 },
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "pushed_to_revolt_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'tvs_verification',
                isSearchable: true,
                options: [
                    { label: 'Accepted', value: 1 },
                    { label: 'Rejected', value: 2 },
                    { label: 'Un Processed', value: 3 },
                    { label: 'Duplicate', value: 4 },
                    { label: 'Dealer Not Found', value: 5 },
                    { label: 'Old Leads', value: 6 }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "tvs_verification_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'pushed_to_tvs',
                options: [
                    { label: 'Completed', value: 1 },
                    { label: 'Pending', value: 2 },
                    { label: 'Rejected', value: 3 },
                    { label: 'Not Eligible', value: 4 },
                    { label: 'DUPLICATE_LEAD', value: 5 },
                    { label: 'Failed to allocate dealer', value: 6 },
                    { label: 'INVALID_PINCODE', value: 7 },
                    { label: 'Success', value: 8 },
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "pushed_to_tvs_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'Ola_Verification',
                isSearchable: true,
                options: [
                    { label: 'Accepted', value: 1 },
                    { label: 'Rejected', value: 2 },
                    { label: 'Un Processed', value: 3 },
                    { label: 'Duplicate', value: 4 },
                    { label: 'Store(B)', value: 7 },
                    { label: 'Store(A)', value: 8 },
                    { label: 'Not Eligible', value: 5 }
                ],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "Ola_Verification_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'ola_addon_status',
                isSearchable: true,
                options: [
                    { value: "EC_APPOINTMENT_SCHEDULED", label: "EC Appointment Scheduled" },
                    { value: "EC_TR_COMPLETED", label: "EC Test Ride Completed" },
                    { value: "HOME_TR_SCHEDULED", label: "Home Test Ride Scheduled" },
                    { value: "EC_CHECK_IN", label: "EC Check-in" },
                    { value: "HOME_TR_COMPLETED", label: "Home Test Ride Completed" },
                ],
                type: 'dropdown',
                isSingleSelection: true
            },
            {
                title: "ola_status_date",
                options: [
                ],
                type: 'daterange'
            },
            {
                title: 'ampere_available',
                options: [
                    { label: 'Available', value: 1 },
                    { label: 'Unavailable', value: 2 },
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "ampere_available_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'evguru_updated',
                options: [
                    { label: 'true', value: 'true' },
                    { label: 'false', value: 'false' },
                ],
                type: 'checkbox',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "evguru_updated_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'RejectMsg',
                isSearchable: true,
                options: [
                    { label: 'There is a existing lead with the same phone number', value: 1 },
                    { label: 'The phone number is already a customer', value: 2 },
                    { label: 'The phone number is mapped to multiple leads', value: 3 }
                ],
                type: 'dropdown'
            },
            {
                title: 'Ola_Status',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Pincode',
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "Pincode_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'PO_State',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'PO_City',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'TC_State',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'EVINDIA_CITY_NAME',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Loan',
                options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                ],
                type: 'checkbox'
            },
            {
                title: 'Tenure',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Down_Payment',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Range',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Evifin',
                options: [
                    { label: 'Available', value: 1 },
                    { label: 'Unavailable', value: 2 },
                ],
                type: 'checkbox'
            },
            {
                title: 'Ecofy',
                options: [
                    { label: 'Available', value: 1 },
                    { label: 'Unavailable', value: 2 },
                ],
                type: 'checkbox'
            },
            {
                title: 'Battery_Wise_Exploration',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'call_yes',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Language',
                isSearchable: true,
                options: [],
                type: 'dropdown'
            },
            {
                title: 'Renav',
                options: [
                    { label: 'true', value: 'true' },
                    { label: 'false', value: 'false' },
                ],
                type: 'checkbox'
            },
            {
                title: 'formType',
                isSearchable: true,
                options: [
                    { label: 'Test Ride', value: 1 },
                    { label: 'On Road Price', value: 2 },
                    { label: 'Get Offers', value: 3 },
                    { label: 'Home test ride', value: 4 },
                    { label: 'Loan', value: 5 }
                ],
                type: 'dropdown'
            },
            {
                title: 'area',
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "area_inc_date",
                options: [],
                type: 'daterange'
            },
            {
                title: 'dealer',
                isSearchable: true,
                options: [],
                type: 'dropdown',
                allowDateRangeWithCheckbox: true,
            },
            {
                title: "dealer_inc_date",
                options: [],
                type: 'daterange'
            },
        ],
        permissionKey: "OLALEADS",
        savePreference: true,
        columnType: "OlaLeads",
    },
};

export default leadConfig